import React from "react";
import { UserRound } from "lucide-react";

function valueFontSize(value) {
  const length = String(value ?? "0").length;
  if (length >= 17) return 14;
  if (length >= 14) return 15;
  if (length >= 11) return 17;
  return 20;
}

export function ReportCard({ title, value, hint, icon: Icon = UserRound }) {
  const displayValue = value ?? 0;

  return (
    <div className="group relative min-w-0 overflow-hidden rounded-[16px] border border-[#f3c8ce] bg-gradient-to-br from-white via-white to-[#fff7f8] px-4 py-3.5 shadow-[0_7px_24px_rgba(216,106,120,0.06)] transition duration-200 hover:-translate-y-0.5 hover:border-[#ecaeb8] hover:shadow-[0_10px_30px_rgba(216,106,120,0.12)]">
      <div className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-[#d86a78] transition-transform duration-200 group-hover:scale-x-100" />
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#f8dce0] text-[#d86a78] ring-1 ring-inset ring-[#f3c8ce]/70">
          <Icon size={20} strokeWidth={2.25} />
        </div>

        <div className="min-w-0 flex-1">
          <div className="truncate text-[10px] font-extrabold uppercase tracking-[0.04em] text-slate-400" title={title}>
            {title}
          </div>
          <div
            className="mt-1 max-w-full whitespace-nowrap font-black leading-none tracking-[-0.035em] text-slate-950 tabular-nums"
            style={{ fontSize: `${valueFontSize(displayValue)}px` }}
            title={String(displayValue)}
          >
            {displayValue}
          </div>
          {hint ? (
            <div className="mt-1.5 truncate text-[10px] font-bold text-emerald-500" title={String(hint)}>
              {hint}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export function EmptyReport({ text = "No report data found" }) {
  return (
    <div className="rounded-[18px] border border-dashed border-[#f2c6cc] bg-[#fff8f9] p-8 text-center text-sm font-bold text-slate-500">
      {text}
    </div>
  );
}

export function ReportPanel({ title, subtitle, right, children, className = "" }) {
  return (
    <div className={`min-w-0 rounded-[18px] border border-[#f4cdd2] bg-white p-4 shadow-[0_8px_30px_rgba(15,23,42,0.035)] ${className}`}>
      {(title || subtitle || right) ? (
        <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            {title ? <h3 className="truncate text-sm font-black text-slate-900" title={title}>{title}</h3> : null}
            {subtitle ? <p className="mt-1 text-[11px] font-semibold leading-relaxed text-slate-400">{subtitle}</p> : null}
          </div>
          {right ? <div className="shrink-0">{right}</div> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
